import {getEventTitle, getFormattedLocation, isTicketed} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {usePageStateSelector} from '../../hooks/state'
import {isCouponInputVisible} from '../../selectors/checkout-options'
import {getDatesInformation} from '../../selectors/dates'
import {getEvent} from '../../selectors/event'
import {isMembershipSelectorVisible} from '../../selectors/paid-plans'
import {CouponInput} from './coupon-input'
import {SummaryProps} from './interfaces'
import {MembershipDropdown} from './membership-dropdown'
import s from './summary.scss'
import {classes} from './summary.st.css'
import {TicketsSummary} from './tickets-summary'

export const Summary = ({currentStep}: SummaryProps) => {
  const event = usePageStateSelector(getEvent)
  const title = getEventTitle(event)
  const date = usePageStateSelector(getDatesInformation).fullDate
  const location = getFormattedLocation(event)
  const ticketed = isTicketed(event)
  const couponInputVisible = usePageStateSelector(isCouponInputVisible)
  const membershipSelectorVisible = usePageStateSelector(isMembershipSelectorVisible)

  return (
    <div className={s.summary} id="event-summary">
      <div className={classNames(s.info, {[s.rsvp]: !ticketed})}>
        <Text className={classes.title} data-hook="event-title">
          {title}
        </Text>
        <div className={classes.dateAndLocation}>
          <Text data-hook="event-time">{date}</Text>
          <Text data-hook="event-location">{location}</Text>
        </div>
      </div>
      {ticketed && (
        <>
          {couponInputVisible && <CouponInput currentStep={currentStep} />}
          {membershipSelectorVisible && <MembershipDropdown currentStep={currentStep} />}
          <TicketsSummary event={event} />
        </>
      )}
    </div>
  )
}
